import React from 'react';
import CloseButton from '@/components/buttons/CloseButton';
import SaveButton from '@/components/buttons/SaveButton';
import { states } from '@/constants/lifecycle';
import { validateRequestSection } from '@/requests/helper';
import TabActions from '@/components/tabs/TabActions';
import RequestEvents from '@/requests/hooks/events';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const WorkspaceRequestActions = ({ code, compact }) => {
  const { form, saveStatus, workspace } = Selectors.useWorkspaceRequestActions({ code });
  const onClose = Events.useDestroyRequestWorkspace({ code });
  const postData = Events.useRequestWorkspace({ code });
  const updateProperties = RequestEvents.useUpdateRequestProperties('workspaces', { code });

  const submitForm = () => {
    const saveErrors = validateRequestSection(workspace, form, 'workspace');

    if (saveErrors.length > 0) {
      updateProperties({ properties: { saveErrors } });
    } else {
      postData();
    }
  };

  return (
    <TabActions className="aridhia-workspace-request-wizard-actions">
      <CloseButton onClick={onClose} disabled={saveStatus === states.PENDING} />
      <SaveButton
        iconOnly={compact}
        inProgress={saveStatus === states.PENDING}
        messageId="actions.request.workspace"
        minimumDataEntryMet
        onClick={submitForm}
      />
    </TabActions>
  );
};

export default WorkspaceRequestActions;
